<template>
  <img
    class="img-fluid lazyload img-day-size"
    v-lazy="image">
</template>

<script>
export default {
  name: 'BaseImage',
  props: {
    image: {
      type: [String, Object],
      required: false
    }
  }
}
</script>
